import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { AppMessage } from '../../core/model/app-message.model';
import { Observable } from 'rxjs/Observable';

/**
 * Component handles information / warning / error messages displaying.
 */
@Component({
    selector: 'ssf-messages',
    template: require('./messages.component.html'),
    styles: [require('./messages.component.scss')]
})
export class MessagesComponent {
    public messages$: Observable<AppMessage[]>;

    constructor(private store: Store<AppState>) {
        this.messages$ = this.store.select(state => state.messages);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/messages/messages.component.ts